import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _DeliveryCertificate, _ImportRegistry, _single } from "../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../theme/Component/usePaginator";
import useModal, { MODAL_LG, MODAL_SM } from "../../theme/Component/hooks/useModal";
import { MASK_DATE, MASK_NUMBER } from "../../theme/Component/BasicMultiSelecTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_DECIMAL } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { GenericItem } from "../ImportRegistry/GenericItem";
import { NationalizationPhoto } from "../OptionComponents/NationalizationPhoto/NationalizationPhoto";
import { SignList } from "../OptionComponents/SignList/SignList";
import { ImportRegistry } from "../ImportRegistry/ImportRegistry";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { InputDate } from "../../theme/Input/InputDate";
import { InputMoney } from "../../theme/Input/InputMoney";
import { DownloadFileCard } from "../../theme/Component/DownloadFileCard";
import { BasicButton } from "../../theme/Component/BasicButton";

type filterProps = {
    Year: number;
    State: number;
    DeliveryCertificateType: number;
    ContractNumber: string;
    ContractObject: string;
}

export const DirectUnchargeDeliveryCertificate = () => {

    const importRegistry = useDataBean(_ImportRegistry);
    const { bean, setBean, lista, setLista, instance, handleChange, isMissing, isRequired, addRequiredFields, validateForm } = useDataBean(_DeliveryCertificate);
    const paginador = usePaginator();

    const [filter, setFilter] = useState<Partial<filterProps>>({
        Year: _single.getCurrenYear(),
        State: 1,
        DeliveryCertificateType: 101,
    })

    const [excelDocument, setExcelDocument] = useState<any>(null);
    const [excelError, setExcelError] = useState<string | null>(null);

    const modalItem = useModal("Items", MODAL_LG);
    const modalEdit = useModal("Editar", MODAL_LG);
    const modalDel = useModal("Eliminar", MODAL_SM);
    const modalImgs = useModal(`Registros fotograficos de ${bean.ContractNumber}`, MODAL_LG);
    const modalSigns = useModal(`Firmas de ${bean.ContractNumber}`, MODAL_LG);
    const modalExcel = useModal(`Reporte de ${bean.ContractNumber}`, MODAL_LG);

    const head = [
        { title: 'No', property: 'IDDeliveryCertificate', mask: MASK_NUMBER },
        { title: 'Contrato', property: 'ContractNumber' },
        { title: 'Objeto del Contrato', property: 'ContractObject', visible: false, Style: { minWidth: "350px" } },
        { title: 'Objeto Contrato', property: 'ContractObject', visible: false },
        { title: 'Ciudad', property: 'SiteName' },
        { title: 'Documento de Transporte', property: 'TransportNumber' },
        { title: 'Fecha Manifiesto', property: 'ManifestDate', mask: MASK_DATE },
        { title: 'Observaciones', property: 'ObservationsEM' },
        { title: 'Tasa de Cambio', property: 'ExchangeRate', mask: MASK_DECIMAL },
        { title: 'Valor fletes y seguros', property: 'FleteValue', mask: MASK_DECIMAL },
        { title: 'Anexo', property: 'AttachStrEM' },
        { title: 'Empleado', property: 'EmpleyeeName' },
    ];

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { addItem() } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalEdit.open() } },
            { titulo: 'Items', icono: 'ri-list-unordered', visible: _single.canEdit(), evento: () => { modalItem.open() } },
            { titulo: 'Registros Fotograficos', icono: 'ri-camera-line', visible: _single.canEdit(), evento: () => { modalImgs.open() } },
            { titulo: 'Descargar Reporte en Excel', icono: 'ri-file-excel-line', visible: _single.canEdit(), evento: () => { getExcel(); } },
            { titulo: 'Firmas', icono: 'ri-quill-pen-line', visible: _single.canEdit(), evento: () => { modalSigns.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDel.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        importRegistry.instance.getFormRegistryRender(_ImportRegistry.HANDOVERCERTIFICATE, paginador.page, 15, _single.cleanMap(filter))
            .then((resp: any) => {
                setLista(resp.List);
                paginador.setPages(resp.NumberOfPages);
            }).catch(err => { toast.error(err) })
    }

    const addItem = () => {
        setBean({
            State: 1,
            DeliveryCertificateType: 101,
        });
        modalEdit.open("Agregar Acta de Entrega");
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const getExcel = () => {
        setExcelDocument(null);
        setExcelError(null);

        importRegistry.instance.getFormatExcelByForm(bean.IDDeliveryCertificate, _single.getAccountID(), importRegistry.instance.HANDOVERCERTIFICATE).then(
            (resp: any) => {
                const document = resp?.Document?.DataBeanProperties
                    ?? resp?.DataBeanProperties?.Document?.DataBeanProperties;

                if (!document?.URL) {
                    setExcelError(document?.ERR ?? "No se genero el archivo Correctamente");
                    modalExcel.open();
                    return;
                }

                setExcelDocument(document);
                modalExcel.open();
            }
        ).catch((err: any) => {
            setExcelError(err?.message ?? String(err ?? "Error desconocido al generar el archivo"));
            modalExcel.open();
        })
    }

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }
        const item = { ...obj, DeliveryCertificateType: 101, IDEmployee: _single.getAccountID() };
        delete item.DeliveryWarehouse;
        delete item.DeliveryDate;
        delete item.ManifestNumber;
        delete item.GrossWeight;
        delete item.InsuranceValue;

        instance.updateDeliveryCertificate(item).then(
            (resp: any) => {
                toast.success("Datos Guardados Correctamente");
                modalEdit.close();
                modalDel.close();
                getLista();
            }
        ).catch(err => { toast.error(err) })

    }

    return (
        <BasicPage titulo="Acta de Entrega - Descargue Directo">
            <div className="row ">
                <div className="col-md-4">
                    <label>Contrato</label>
                    <input type="text" className="form-control" value={filter.ContractNumber} onChange={(e) => { setFilter({ ...filter, ContractNumber: e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <label>Objeto del Contrato</label>
                    <input type="text" className="form-control" value={filter.ContractObject} onChange={(e) => { setFilter({ ...filter, ContractObject: e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={"Buscar"} useMargin />
                </div>

                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} records={paginador} />

                    <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${isMissing('IDImportRegistry') ? 'has-error' : ''}`}>Contrato / Donacion {isRequired('IDImportRegistry') ? <span className="text-danger">*</span> : ''}</label>
                                <ImportRegistry label=" " editor={true} idSelector={bean.IDImportRegistry} onChange={(e) => { setBean({ ...bean, IDImportRegistry: e.IDImportRegistry }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('SiteName') ? 'has-error' : ''}`}>Ciudad {isRequired('SiteName') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.SiteName ?? ''} onChange={(e) => { setBean({ ...bean, SiteName: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('TransportNumber') ? 'has-error' : ''}`}>Documento de transporte {isRequired('TransportNumber') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.TransportNumber} onChange={(e) => { setBean({ ...bean, TransportNumber: e.target.value }) }} />
                            </div>

                            <div className="col-md-6">
                                <label className={`${isMissing('ManifestDate') ? 'has-error' : ''}`}>Fecha manifiesto {isRequired('ManifestDate') ? <span className="text-danger">*</span> : ''}</label>
                                <InputDate name="ManifestDate" value={bean.ManifestDate} setDate={(e) => { setBean({ ...bean, ManifestDate: e }) }} label=" " />
                            </div>
                            <div className="col-md-6">
                                <label className={`${isMissing('ExchangeRate') ? 'has-error' : ''}`}>Tasa de Cambio {isRequired('ExchangeRate') ? <span className="text-danger">*</span> : ''}</label>
                                <InputMoney _style="decimal" _value={bean.ExchangeRate} _label=" " onChange={(e) => { setBean({ ...bean, ExchangeRate: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${isMissing('FleteValue') ? 'has-error' : ''}`}>Valor fletes y seguros {isRequired('FleteValue') ? <span className="text-danger">*</span> : ''}</label>
                                <InputMoney _style="decimal" _value={bean.FleteValue} _label=" " onChange={(e) => { setBean({ ...bean, FleteValue: e }) }} />
                            </div>

                            <div className="col-md-12">
                                <label className={`${isMissing('AttachStrEM') ? 'has-error' : ''}`}>Anexo {isRequired('AttachStrEM') ? <span className="text-danger">*</span> : ''}</label>
                                <input type="text" className="form-control" value={bean.AttachStrEM} onChange={(e) => { setBean({ ...bean, AttachStrEM: e.target.value }) }} />
                            </div>

                            <div className="col-md-12">
                                <label >Observaciones</label>
                                <textarea name="ObservationsEM" value={bean.ObservationsEM} onChange={handleChange} className="form-control" />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={() => { deleteItem(); }}>
                        Eliminar fima de {bean.IDDeliveryCertificate} - {bean.ContractNumber}
                    </ModalConfirm>

                    <Modal modal={modalItem.modal} updateModal={modalItem.setModal}>
                        <GenericItem typeForm={_ImportRegistry.HANDOVERCERTIFICATE} formBean={bean} />
                    </Modal>

                    <Modal modal={modalImgs.modal} updateModal={modalImgs.setModal} >
                        <NationalizationPhoto isModal idFormType={bean.IDDeliveryCertificate} formType={_ImportRegistry.HANDOVERCERTIFICATE} />
                    </Modal>

                    <Modal modal={modalSigns.modal} updateModal={modalSigns.setModal} >
                        <SignList isModal idFormType={bean.IDDeliveryCertificate} formType={_ImportRegistry.HANDOVERCERTIFICATE} />
                    </Modal>

                    <Modal modal={modalExcel.modal} updateModal={modalExcel.setModal}>
                        <DownloadFileCard
                            file={excelDocument}
                            error={excelError}
                            fallbackName="Reporte.xlsx"
                            fileTypeLabel="Archivo Excel"
                            buttonLabel="Descargar Excel"
                            icon="ri-file-excel-2-line"
                            iconClassName="text-success"
                            buttonClassName="btn-success"
                        />
                    </Modal>

                </div>
            </div>
        </BasicPage>
    )
}
